module.exports = __webpack_public_path__ + "static/img/signify.3192499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/signify.jpg
// module id = il7P
// module chunks = 0